import { Container, ResourceIndicator } from '@bit/ui-common.ui-components/ss-components';
import { Switch, Route, } from 'react-router-dom';
import { ssFormServices } from '@bit/ui-common.ui-components/ss-utils';
// import Home from 'containers/Home';
import PRALayout from 'components/layouts/PRALayout';
import PASLayout from 'components/layouts/PASLayout';
import { getServices, ROUTES, WINDOW } from 'utils/utils';
import { PaymentConfirmation, ExpiredSessionModal} from '@bit/ui-common.ui-components/ss-common-data';
import * as AppServices from 'services/appService';
import * as RegistrationCheckService from 'services/registrationCheckService';
import * as passwordUpdate from 'services/updatePasswordService'
import * as ProviderService from 'services/provider/providerService';
import * as SessionServices from '../redux/services/sessionService';
import { commonData, captcha } from '@bit/ui-common.ui-components/ss-common-data';
import DodRegistration from './DodRegistration';
import FsdoRegistration from './FsdoRegistration';
import ProviderRegistration from './ProviderRegistration';
import Reset from './Reset';
import Help from './Help';
import Ftttf from './Ftttf';
import CandidateRegistration from './CandidateRegistration';
import CandidateRecovery from './CandidateRecovery';
import moment from 'moment-timezone';
import { withCookies } from 'react-cookie';
import ProviderPortal from './portals/ProviderPortal';
import FsdoPortal from './portals/FsdoPortal';
import DodPortal from './portals/DodPortal';
import AnalystPortal from './portals/AnalystPortal';
import CandidatePortal from './portals/CandidatePortal';
import HomePortal from './portals/HomePortal';
import ExternalLinkWarning from '../components/ExternalLinkWarning';
import { ssSessionUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
{ redirectToHome } = ssSessionUtils,
{ setEnvPrefix } = ssCommonUtils,
{ ROOT, HOME, PAYMENT } = ROUTES;

export default withCookies(Container({
    withRouter: true,
    services: [
        AppServices,
        RegistrationCheckService,
        commonData.commonDataServices,
        passwordUpdate,
        ProviderService,
        captcha.captchaServices,
        ssFormServices,
        SessionServices
    ]
},
class App extends React.Component {
    constructor(props) {
        super(props);
        moment.tz.setDefault('UTC');
        const { services } = this.props;
        this.services = this.getServices();
        services.fetchTextData();
        services.fetchGeoData();
        services.fetchLookupData();
    }
    componentDidMount () {

        let params = undefined;
        const currentUrl = window.location.href;
        let s = document.createElement('script'); 
        s.type = 'text/javascript'; 
        s.id = '_fed_an_ua_tag'; 
        s.async = true; 
        if(currentUrl.includes('localhost') || 
        currentUrl.includes('test')  ||
        currentUrl.includes('stage') ||
        currentUrl.includes('dev')   || 
        currentUrl.includes('dts')   || 
        currentUrl.includes('uts')) {
            params = '?'+'agency=DHS&dapdev=true'; 
            //Analytics is disabled for the lower environment so this has been commented out
            // s.src = 'https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js'+params; 
            // let x = document.getElementsByTagName('script')[0]; 
            // x.parentNode.insertBefore(s, x); 
        }else{
            params = '?'+'agency=DHS'; 
            s.src = 'https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js'+params; 
            let x = document.getElementsByTagName('script')[0]; 
            x.parentNode.insertBefore(s, x); 
        }
    }

    getServices() {
        const { services } = this.props;
        return {
            home: getServices(services, [
                'setData',
                'doRequest',
                'setSessionData',
                'storeForm',
                'storeFormField',
                'togglePasswordUpdateView'
            ]),
            registration: services,
            pra: getServices(services, ['setData', 'doRequest']),
            pas: getServices(services, ['setData', 'doRequest']),
            passwordUpdate: getServices(services, ['updateNewPassword', 'updatePassword']),
            resetPassword: getServices(services, ['doRequest']),
            newEmail: getServices(services, ['resetEmail'])
        }
    }

    getPathParams() {
        let
        result = {},
        params = window.location.search;

        if (params != null && params !== '') {
            ((params.substring(1, params.length)).split('&')).forEach(e => {
                let tokens = e.split('=');
                result[tokens[0]] = tokens[1];
            });
            return result;
        } else return null;
    }

    render() {
        const
        { services } = this,
        { win, app, session, captcha, red, registrationForm, recoveryForm } = this.props.state,
        { displayType } = win,
        { DESKTOP_MENU } = WINDOW,
        { textData, geoData, lookupData } = this.props.state.commonData,
        { cookies } = this.props;

        let
        appStyle = {},
        queryParams = this.getPathParams(),
        layoutProps = { win, state: { app, session }},
        praProps = {...layoutProps, services: services.pra },
        pasProps = {...layoutProps, services: services.pas },
        pathProps = { services: this.props.services, win, appStyle, session, pasProps, praProps, captcha, app, registrationForm };
        
        if(displayType === DESKTOP_MENU) {
            // The minimum dimensions of the display are set to
            // 720p at a 16:9 aspect ratio, which is 1280x720.
            appStyle.minWidth = win.minWidth;
            appStyle.minHeight = win.minHeight;
        }

        return (
            <div>
                <ResourceIndicator resources={{ textData, geoData, lookupData }} />
                {queryParams ? (
                    queryParams.portal === 'dod' ? <DodRegistration /> :
                    queryParams.portal === 'fsdo' ? <FsdoRegistration /> :
                    <AppPaths cookies={cookies} queryParams={queryParams} red={red} {...pathProps} />
                ) : <AppPaths cookies={cookies} queryParams={queryParams} red={red} {...pathProps} />}
            </div>
        );
    }
}))

class AppPaths extends React.Component {
    constructor(props) { super(props); }

    render = () => {
        //redirectToHome();
        let tab = null;
        const { 
            win, 
            app, 
            red, 
            captcha, 
            session, 
            services, 
            appStyle, 
            pasProps, 
            praProps, 
            queryParams, 
            registrationForm 
        } = this.props,
        altUserId = app.login.login.userId.value,
        userId = !registrationForm.hasOwnProperty('login') ? altUserId 
            : !registrationForm.login.hasOwnProperty('username') ? altUserId 
                : registrationForm.login.username;

        if(queryParams != null) {
            if(queryParams.hasOwnProperty('tab')) tab = queryParams.tab;
            if(queryParams.hasOwnProperty('session') && !session.showSesionExpiredModal)
                services.toggleSessionExpiredModdal();
        }
        
        // <Route path={ROOT} render={() => <Home {...captcha} cookies={this.props.cookies} win={win} red={red} tab={tab} />} />
        return (
            <div style={appStyle}>
                <ExpiredSessionModal
                    visible={session.showSesionExpiredModal}
                    onClick={(e) => {
                        services.toggleSessionExpiredModdal();
                        window.location.search = '';
                    }}
                />
              
                
                <Switch>
                    <Route exact path={setEnvPrefix(`/ftttf`)} render={props => <Ftttf {...props} />} />
                    <Route exact path={HOME.HELP} render={props => <Help {...props} />} />
                    <Route exact path={HOME.PRA} render={() => <PRALayout {...praProps }/>} />
                    <Route exact path={HOME.PAS} render={() => <PASLayout {...pasProps }/>} />
                    <Route exact path={HOME.CANDIDATE_REGISTRATION} render={() => <CandidateRegistration />} />
                    <Route exact path={HOME.CANDIDATE_RECOVERY} render={() => <CandidateRecovery />} />
                    <Route exact path={HOME.PROVIDER_REGISTRATION} render={() => <ProviderRegistration />} />
                    <Route exact path={HOME.RESET_PASSWORD} render={props => <Reset type='reset-password' token={(s => s.substring(1, s.length))(props.location.search)} />} />
                    <Route exact path={HOME.RESET_EXPIRED_PASSWORD} render={() => <Reset type='reset-expired-password' id={userId} />} />
                    <Route exact path={HOME.RESET_ACCOUNT_REQUEST} render={() => <Reset type='reset-password-request'/>} />
                    <Route exact path={HOME.REACTIVATE_USER} render={props => <Reset type='reactivate-user' token={(s => s.substring(1, s.length))(props.location.search)} />} />
                    <Route path={PAYMENT.CONFIRM} render={props => <PaymentConfirmation {...props }/>} />
                    <Route exact path={setEnvPrefix(`/home/dod`)} render={() => <DodPortal />} />
                    <Route exact path={setEnvPrefix(`/home/fsdo`)} render={() => <FsdoPortal />} />
                    <Route exact path={setEnvPrefix(`/home/provider`)} render={() => <ProviderPortal />} />
                    <Route exact path={setEnvPrefix(`/home/analyst`)} render={() => <AnalystPortal />} />
                    <Route exact path={setEnvPrefix(`/home/candidate`)} render={() => <CandidatePortal />} />
                    <Route exact path={setEnvPrefix(`/home/warning`)} render={props => <ExternalLinkWarning {...props} />} />
                    <Route path={ROOT} render={() => <HomePortal />} />
                </Switch>
            </div>
        );
    }
}
